const data = {
	"width": 24,
	"height": 24,
	"body": "<path fill=\"currentColor\" d=\"M8.025 22L6.25 20.225L14.475 12L6.25 3.775L8.025 2l10 10Z\"/>"
};
exports.__esModule = true;
exports.default = data;
